// Distances, bounds and the reader's position.

export function haversineMiles(lat1, lng1, lat2, lng2) {
  const R = 3958.8;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export function formatMiles(mi, lang = 'en') {
  if (!Number.isFinite(mi)) return '';
  if (lang === 'es') { const km = mi * 1.609; return km < 10 ? `${km.toFixed(1)} km` : `${Math.round(km)} km`; }
  return mi < 10 ? `${mi.toFixed(1)} mi` : `${Math.round(mi)} mi`;
}

/** [[west, south], [east, north]] of a set of points, or null. */
export function boundsOf(points) {
  let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
  for (const p of points) {
    if (p.lng < w) w = p.lng; if (p.lng > e) e = p.lng;
    if (p.lat < s) s = p.lat; if (p.lat > n) n = p.lat;
  }
  return Number.isFinite(w) ? [[w, s], [e, n]] : null;
}

/** Centroid of points, for a place with no stored centre. */
export function centroidOf(points) {
  if (!points.length) return null;
  let lat = 0, lng = 0;
  for (const p of points) { lat += p.lat; lng += p.lng; }
  return [lng / points.length, lat / points.length];
}

/**
 * The reader's position: the browser's, then Cloudflare's guess from the
 * request. Resolves { lat, lng, accuracy, source } or null; never throws.
 */
export function locate({ timeout = 8000 } = {}) {
  const browser = new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy || 50, source: 'device' }),
      () => resolve(null),
      { enableHighAccuracy: false, timeout, maximumAge: 60000 },
    );
  });
  return browser.then((hit) => hit || fetch('/api/geo', { credentials: 'same-origin' })
    .then((r) => r.json())
    .then((d) => (d && d.success && Number.isFinite(+d.lat) && Number.isFinite(+d.lng)) ? { lat: +d.lat, lng: +d.lng, accuracy: 20000, source: 'network' } : null)
    .catch(() => null));
}
